import { Picture } from './src/Picture'
export { Picture }
export default Picture



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/components/Picture/index.ts